import * as React from 'react';

import Divider from 'bundles/ondemand/components/s12n-upgrade/Divider';

import S12NCourseProgress from './S12NCourseProgress';

type Course = {
  id: string;
  name: string;
};

// keyed by course id
type ProgressStatusMap = Record<
  string,
  {
    status?: string;
    progress?: string;
  }
>;

type Props = {
  courses: Course[];
  progressStatus: ProgressStatusMap;
};

class S12nInfo extends React.Component<Props> {
  static defaultProps = {
    courses: [],
    progressStatus: {},
  };

  renderCourseProgress = () => {
    const { courses, progressStatus } = this.props;
    const numCourses = courses.length;

    return courses.map((course: Course, idx: number) => {
      const isLast = idx === numCourses - 1;
      const id = course.id;
      return (
        <div key={id}>
          <Divider />
          <S12NCourseProgress course={course} progressStatus={progressStatus[id]} />
          {isLast && <Divider />}
        </div>
      );
    });
  };

  render() {
    return <div className="rc-S12nInfo vertical-box">{this.renderCourseProgress()}</div>;
  }
}

export default S12nInfo;
